module.exports = __webpack_public_path__ + "static/hkgrotesk-mediumitalic-7dd11fdfcbe5992e84dfd64c2163495f.woff2";